<template>
  <div class="uk-grid-medium" uk-grid>
    <div class="uk-width-5-5">
      <div class="d-flex">
        <nav id="breadcrumbs" class="mb-3">
          <ul>
            <li>
              <router-link :to="{ name: 'company.dashboard' }">
                <i class="uil-home-alt"></i>
              </router-link>
            </li>
            <li>{{ $t('general.payment_transactions') }}</li>
          </ul>
        </nav>
      </div>

      <!-- <div id="shareSettings" class="uk-modal" uk-modal>
        <div class="uk-modal-dialog bggray">
          <div class="uk-padding-small" uk-grid>
            <h4> {{ $t('general.sharing_settings') }}</h4>
          </div>
          <div class="row p-4">
            <div class="col-lg-12">
              <div class="form-group row mb-2">
                <label class="col-md-6 col-form-label" for="website_keywords">
                  Onay Gerekli Değil
                  <i class="uil-info-circle" uk-tooltip="title: " title="" aria-expanded="false"></i></label>
                <div class="col-md-6">
                  <label class="uk-switch" for="default-1" v-if="experience_shareable != null">
                    <input type="checkbox" id="default-1" v-model="experience_shareable"
                      @change="handleExperienceSharing" />
                    <div class="uk-switch-slider"></div>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="uk-modal-footer uk-text-right bggray">
            <button class="uk-button uk-button-default small uk-modal-close" type="button">
              <i class="uil-times"></i> {{ $t("general.close") }}
            </button>
          </div>
        </div>
      </div> -->

      <div class="section-header mb-lg-2 border-0 uk-flex-middle">
        <div class="section-header-left">
          <h2 class="uk-heading-line text-left"><span>{{ $t('general.payments') }}</span></h2>
        </div>
        <!-- <div class="section-header-right">
          <a class="btn btn-secondary" style="background-color: red;" @click="removePosts()">
            <i class="uil-minus-circle"></i>Tüm Paylaşımları Sil
          </a>
        </div> -->
        <!-- <div class="section-header-right">
          <a class="btn btn-default dropdown-arrow text-white" uk-toggle="target: #shareSettings"
            uk-tooltip="Paylaşım Ayarları">
            {{ $t('general.sharing_settings') }}
          </a>
        </div> -->
      </div>

      <template v-if="errorMessages">
        <div v-for="(error, index) in errorMessages" :key="index" class="uk-alert-danger" uk-alert>
          <a class="uk-alert-close" uk-close></a>
          <p style="color: red">
            <i class="uil-exclamation-triangle"></i> {{ error }}
          </p>
        </div>
      </template>
      <div v-if="successMessage" class="uk-alert-success" uk-alert>
        <a class="uk-alert-close" uk-close></a>
        <p style="color: green">
          <i class="uil-exclamation-triangle"></i> {{ successMessage }}
        </p>
      </div>

      <div class="card">
        <!-- Card header -->
        <div class="card-header actions-toolbar border-0">
          <div class="d-flex justify-content-between align-items-center">
            <!-- <h4 class="d-inline-block mb-0"></h4> -->
            <div class="row" style="width:100%">
              <div class=" col-md-1  search-icon ">
                <i class="uil-search"></i>
              </div>
              <div class="col-md-11 uk-search uk-search-navbar" style="margin-left:-2rem">
                <input v-model="filter.search" :placeholder="$t('general.search')" autofocus=""
                       class="uk-search-input shadow-0 uk-form-small" type="search"/>
                <!-- <a href="#" class="btn btn-icon btn-hover btn-circle" aria-expanded="false">
                <i class="uil-search"></i>
              </a>
              <div class="uk-drop" uk-drop="mode: hover; pos: right-center; offset: 0" style="left: 91px; top: 159.297px;">
                <form class="uk-search uk-search-navbar uk-width-1-1">
                  <input class="uk-search-input shadow-0 uk-form-small"
                  type="search"
                    v-model="filter.search"
                    :placeholder="$t('general.search')" autofocus="">
                </form>-->
              </div>
            </div>
            <div class="d-flex">
              <!-- Shorting -->
              <a :uk-tooltip="$t('filters.order.sort')" aria-expanded="false" class="btn btn-icon btn-hover btn-circle"
                 href="#" title="">
                <i class="uil-list-ui-alt"></i>
              </a>
              <div class="uk-dropdown" uk-dropdown="pos: bottom-right ; mode: click ;animation: uk-animation-scale-up">
                <ul class="uk-nav uk-dropdown-nav">
                  <li @click="sortOrder('text', 'asc')">
                    <a href="javascript:void(0)">{{ $t("sorting.a_z") }}</a>
                  </li>
                  <li @click="sortOrder('text', 'desc')">
                    <a href="javascript:void(0)">{{ $t("sorting.z_a") }}</a>
                  </li>
                  <li @click="sortOrder('created_at', 'asc')">
                    <a href="javascript:void(0)">
                      {{ $t("sorting.created_at_asc") }}</a>
                  </li>
                  <li @click="sortOrder('created_at', 'desc')">
                    <a href="javascript:void(0)">
                      {{ $t("sorting.created_at_desc") }}</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <!-- Table -->
        <div class="table-responsive">
          <table class="table align-items-center">
            <thead>
            <tr>
              <th scope="col"> {{ $t('general.user_id') }}</th>
              <th scope="col"> {{ $t('profile.full_name') }}</th>
              <th scope="col"> {{ $t('general.product_name') }}</th>
              <th scope="col"> {{ $t('general.product_type') }}</th>
              <th scope="col"> {{ $t('general.price') }}</th>
              <th scope="col"> {{ $t('general.bin_number') }}</th>
              <th scope="col"> {{ $t('general.ip_address') }}</th>
              <th scope="col"> {{ $t('general.status') }}</th>
              <th scope="col"> {{ $t('general.order_date') }}</th>
              <th scope="col"> {{ $t('general.updated_date') }}</th>
              <th scope="col"> {{ $t('general.bank_response') }}</th>
              <!-- <th scope="col">Fatura Yükle</th> -->
            </tr>
            </thead>
            <tbody class="list">
            <!--user item-->
            <tr v-for="(order, index) in orders" :key="index">
              <td>{{ order.user.id }}</td>
              <td>{{ order.user.name }}</td>
              <td>{{ order.order_data[0].title }}</td>
              <td>{{ $t(`general.order.${order.order_data[0].type}`) }}</td>
              <td> {{ formatPrice(order.order_data[0].price, order.order_data[0].currency) }}</td>
              <td>{{ order.bin_number }}</td>
              <td>{{ order.ip }}</td>

              <td>
                  <span :class="getStatusClass(order.status)" class="status-badge">
                    {{ $t(`general.order.${order.status}`) }}
                  </span>
              </td>
              <td>{{ dateFormat(order.created_at) }}</td>
              <td>{{ dateFormat(order.updated_at) }}</td>

              <td>
                <div class="upload-container">
                  <button :class="{ 'btn-disabled': !order.bank_response, 'btn-active': order.bank_response  }"
                          :disabled="!order.bank_response"
                          :uk-tooltip="order.bank_response ? $t(`general.view`) : ''"
                          class="btn btn-bank-response"
                          @click="triggerBankInfo(order)"
                  >
                    <i class="uil-file-alt"></i>
                  </button>
                </div>
              </td>

              <!-- <td>
                <div class="upload-container">
                  <button class="btn btn-info upload-btn" @click="triggerFileInput(index)">
                    <i class="uil-upload"></i> {{ $t("general.upload") }}
                  </button>
                  <input type="file" ref="fileInputs" accept=".pdf" class="hidden-input"
                    @change="handleFileUpload($event, order.token)" />
                </div>
              </td> -->

            </tr>

            </tbody>
          </table>
          <pagination :pagination="pagination" class="mt-2 mb-3" @changePage="setPage($event)"></pagination>
        </div>
      </div>
    </div>

    <!-- Bank Response Modal -->
    <div id="bankResponseModal" class="uk-modal" uk-modal>
      <div class="uk-modal-dialog uk-modal-body">
        <div class="modal-header">
          <h2 class="uk-modal-title">{{ $t('general.bank_response') }}</h2>
          <button class="uk-modal-close-default" type="button" uk-close></button>
        </div>
        <div class="uk-modal-body">
          <pre class="bank-response-content"><code>{{ formattedBankResponse }}</code></pre>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataTable from "@/assets/components/dataTable/DataTable";
import store from "@/core/services";
import moment from "moment";
import { MODULE_NAME as COMPANY_MODULE, } from "@/core/services/store/company.module";
import { GET_ITEMS, UPDATE_ITEM_BY_ID } from "@/core/services/store/REST.module";
import Pagination from "@/assets/components/Pagination";
import { formatPrice } from "@/utils/money";
import axios from "axios";

const _COMPANY_MODULE = COMPANY_MODULE;

export default {
  name: "PaymentHistoryContent",
  components: {
    DataTable,
    Pagination
  },
  data() {
    return {
      orders: [],
      fileName: null,
      uploadError: null,
      companyUrl: "api/company/self",
      ordersUrl: "api/payment-histories",
      sharesUrl: "api/shares-management",
      status_id: 1,
      pagination: null,
      activeItem: null,
      successMessage: null,
      errorMessages: [],
      page: 1,
      company: null,
      experience_shareable: null,
      per_page: 10,
      filter: {
        search: null,
        order: "desc",
        sort: "created_at",
      },
      selectedBankResponse: null,
    };
  },
  beforeCreate() {
    function registerStoreModule(moduleName, storeModule) {
      if (!(store && store.state && store.state[moduleName])) {
        store.registerModule(moduleName, storeModule);
      }
    }
  },
  computed: {
    error: {
      get() {
        return store.getters[MODULE_NAME + "/" + ERROR];
      },
      set(value) {
      },
    },
    formattedBankResponse() {
      if (!this.selectedBankResponse) return '';
      try {
        const response = typeof this.selectedBankResponse === 'string'
            ? JSON.parse(this.selectedBankResponse)
            : this.selectedBankResponse;
        return JSON.stringify(response, null, 2)
            .replace(/,/g, ',\n')
            .replace(/{/g, '{\n')
            .replace(/}/g, '\n}')
            .replace(/\[/g, '[\n')
            .replace(/\]/g, '\n]');
      } catch (error) {
        console.error('Error formatting bank response:', error);
        return this.selectedBankResponse;
      }
    }
  },
  methods: {
    formatPrice,
    getStatusClass(status) {
      const statusMap = {
        'init': 'status-init',
        'success': 'status-success',
        'fail': 'status-failed'
      };
      return statusMap[status] || 'status-init';
    },
    triggerBankInfo(order) {
      if (!order.bank_response) return;
      this.selectedBankResponse = order.bank_response;
      UIkit.modal('#bankResponseModal').show();
    },
    dateFormat(date) {
      return moment(date).format("DD MMMM YYYY HH:mm")
    },
    triggerFileInput(index) {
      this.$refs.fileInputs[index].click();
    },
    handleFileUpload(event, token) {
      const file = event.target.files[0];
      if (!file) return;
      this.uploadPDF(file, token);
    },
    uploadPDF(file, token) {
      const formData = new FormData();
      formData.append('invoice_file', file);

      axios.post('/api/order-update-invoice/' + token, formData)
          .then(response => {
          })
          .catch(error => {
            console.error('Dosya yükleme hatası:', error);
          });

    },
    getOrders() {
      let self = this;
      this.$store
          .dispatch(GET_ITEMS, {
            url: self.ordersUrl,
            acceptPromise: true,
            filters: {
              search: self.filter.search,
              page: self.page,
              per_page: self.per_page,
              sort: self.filter.sort,
              order: self.filter.order,
            },
          })
          .then((result) => {
            if (result) {
              this.pagination = result.data.meta;
              this.orders = result.data.data
            }
          });
    },
    handleExperienceSharing() {
      let self = this;
      let formData = new FormData();
      formData.append(
          "experience_shareable",
          self.experience_shareable === true ? 1 : 0
      );
      this.$store.dispatch(UPDATE_ITEM_BY_ID, {
        url: self.companySharingUrl + self.company.id,
        contents: formData,
        acceptPromise: false,
      });
    },
    sortOrder(sort, order) {
      let self = this;
      self.page = 1;
      self.filter.order = order;
      self.filter.sort = sort;
      this.getOrders();
    },
    setPage(page) {
      let self = this;
      self.page = page;
      this.getOrders();
    },
    resetMessages() {
      this.successMessage = null;
      this.errorMessages = [];
    },
  },
  mounted() {
    this.getOrders();
  },
  beforeDestroy() {
    const modal = UIkit.modal("#shareSettings");
    if (modal) modal.$destroy(true);
  },
  watch: {
    "filter.search": function (val) {
      this.page = 1;
      this.debouncedFilterSearch();
    },
    successMessage: function (val) {
      this.debouncedResetValues();
    },
    errorMessages: function (val) {
      this.debouncedResetValues();
    },
  },
  created: function () {
    this.debouncedFilterSearch = _.debounce(this.getOrders, 500);
    this.debouncedResetValues = _.debounce(this.resetMessages, 2000);
  },
};
</script>
<style scoped>
input[type="button"],
input[type="submit"],
span.btn,
.btn {
  display: inline-block;
}

.cursor-pointer {
  cursor: pointer;
}

.upload-container {
  display: flex;
  justify-content: center;
  align-items: center;
  float: left;
}

.upload-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  font-size: 16px;
  cursor: pointer;
  border-radius: 6px;
  border: none;
}

.hidden-input {
  display: none;
}

/* Bank Response Modal Styles */
.bank-response-content {
  background-color: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 4px;
  padding: 1rem;
  margin: 0;
  max-height: 70vh;
  overflow-y: auto;
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', 'Consolas', 'source-code-pro', monospace;
  font-size: 0.875rem;
  line-height: 1.5;
  color: #333;
  white-space: pre;
  word-wrap: break-word;
}

.bank-response-content code {
  display: block;
  padding: 0.5rem;
  background-color: #f8f9fa;
  border-radius: 4px;
  white-space: pre;
}

/* Syntax Highlighting */
.bank-response-content .string {
  color: #28a745;
}

.bank-response-content .number {
  color: #007bff;
}

.bank-response-content .boolean {
  color: #dc3545;
}

.bank-response-content .null {
  color: #6c757d;
}

.bank-response-content .key {
  color: #6f42c1;
}

/* Modal Styles */
.uk-modal-dialog {
  max-width: 800px !important;
  width: 90%;
  margin: 30px auto;
}

.modal-header {
  padding: initial;
  border-bottom: 1px solid #e9ecef;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.modal-header .uk-modal-title {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 500;
  color: #333;
}

.uk-modal-close-default {
  padding: 0.5rem;
  color: #6c757d;
  opacity: 0.7;
  transition: opacity 0.15s ease;
}

.uk-modal-close-default:hover {
  opacity: 1;
}

/* Bank Response Button Styles */
.btn-bank-response {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  font-size: 0.875rem;
  color: #fff;
  background-color: #3699ff;
  border: 1px solid #3699ff;
  border-radius: 4px;
  transition: all 0.2s ease;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.btn-bank-response.btn-active {
  background-color: #3699ff;
  border-color: #3699ff;
  color: #fff;
}

.btn-bank-response.btn-active:hover {
  background-color: #187de4;
  border-color: #187de4;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.btn-bank-response.btn-active:active {
  transform: translateY(0);
  box-shadow: none;
}

.btn-bank-response.btn-active i {
  animation: pulse 2s infinite;
}

.btn-bank-response.btn-disabled {
  background-color: #f5f8fa;
  border-color: #e4e6ef;
  color: #b5b5c3;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.btn-bank-response.btn-disabled:hover {
  background-color: #f5f8fa;
  border-color: #e4e6ef;
  transform: none;
  box-shadow: none;
}

.btn-bank-response i {
  font-size: 1rem;
  transition: all 0.2s ease;
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}

/* Tooltip Styles */
[uk-tooltip] {
  cursor: pointer;
}

[uk-tooltip]:before {
  font-size: 0.75rem;
  padding: 0.375rem 0.75rem;
  border-radius: 3px;
  background-color: #3e416d;
  color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  white-space: nowrap;
}

/* Responsive Styles */
@media (max-width: 768px) {
  .btn-bank-response {
    min-width: auto;
    padding: 6px;
  }

  .btn-bank-response span {
    display: none;
  }

  .btn-bank-response i {
    margin: 0;
  }
}

/* banka sonucu - başarılı başarısız */
.status-badge {
  display: inline-flex;
  align-items: center;
  padding: 0.25rem 0.75rem;
  font-size: 0.75rem;
  font-weight: 500;
  border-radius: 4px;
  white-space: nowrap;
}

.status-init {
  background-color: #fff4de;
  color: #ffa800;
  border: 1px solid #ffd699;
}

.status-success {
  background-color: #e8fff3;
  color: #1bc5bd;
  border: 1px solid #b5f5ec;
}

.status-failed {
  background-color: #ffe2e5;
  color: #f64e60;
  border: 1px solid #ffb5b5;
}
</style>
